<iris-card class="client-detail-assessment-type" >
  <h2 data-test="assessment-type-header" data-dd-privacy="allow">
    {{ displayTitle }}
  </h2>

  <ng-container *ngIf="data">
    <member-clinical-questionnaire-summary
      [analyticSummary]="data.analytics"
      [totalSessions]="data.totalSessions"
    ></member-clinical-questionnaire-summary>

    <member-clinical-questionnaires-overview
      [recentAssessments]="data.assessments"
      [initialAssessment]="data.initialAssessment"
      [totalAssessments]="data.totalAssessments || 0"
    ></member-clinical-questionnaires-overview>
  </ng-container>

  <member-clinical-questionnaire-scoring [assessmentType]="assessmentType"></member-clinical-questionnaire-scoring>

</iris-card>
